import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const CONSENT_KEY = 'lumera_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem(CONSENT_KEY, 'dismissed');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 inset-x-0 z-[9999] pointer-events-none"
      style={{ animation: 'slideUp .4s cubic-bezier(.22,1,.36,1) forwards' }}
    >
      <div className="max-w-2xl mx-auto px-3 sm:px-4 pb-3 sm:pb-5 pointer-events-auto">
        <div className="bg-stone-900 rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,.25)] border border-stone-800 px-3 sm:px-5 py-3 sm:py-4 flex items-center gap-3 sm:gap-4">
          <Cookie className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400 flex-shrink-0" />
          <p className="font-sans text-[11px] sm:text-[13px] text-stone-300 leading-snug sm:leading-relaxed flex-1 min-w-0">
            Essential cookies only.{' '}
            <Link to="/cookies" className="text-amber-400 hover:underline font-medium">Learn more</Link>
          </p>
          <div className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0">
            <button
              data-testid="cookie-accept-btn"
              onClick={accept}
              className="bg-white text-stone-900 font-sans font-semibold text-[11px] sm:text-xs rounded-full px-3 sm:px-4 py-1.5 sm:py-2 hover:bg-stone-100 transition-colors"
            >
              Accept
            </button>
            <button
              data-testid="cookie-dismiss-btn"
              onClick={dismiss}
              className="text-stone-500 hover:text-stone-300 transition-colors p-0.5 sm:p-1"
              aria-label="Close"
            >
              <X className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default CookieConsent;
